var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6496 7.00015L13.6579 1.99175C14.114 1.53559 14.114 0.798275 13.6579 0.342118C13.2017 -0.114039 12.4644 -0.114039 12.0083 0.342118L7 5.35051L1.99171 0.342118C1.53556 -0.114039 0.798258 -0.114039 0.342111 0.342118C-0.114037 0.798275 -0.114037 1.53559 0.342111 1.99175L5.3504 7.00015L0.342111 12.0085C-0.114037 12.4647 -0.114037 13.202 0.342111 13.6582C0.569601 13.8857 0.868255 14 1.16691 14C1.46556 14 1.76422 13.8857 1.99171 13.6582L7 8.64978L12.0083 13.6582C12.2358 13.8857 12.5344 14 12.8331 14C13.1317 14 13.4304 13.8857 13.6579 13.6582C14.114 13.202 14.114 12.4647 13.6579 12.0085L8.6496 7.00015Z",
    fill: "#7B819B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFile);
export default __webpack_public_path__ + "static/media/closeFile.1ae4e2725dbfad799b93e0564718c861.svg";
export { ForwardRef as ReactComponent };